// @ts-nocheck
/* eslint-disable */ /* GENERATED USING build-GemIcons.ts - DO NOT MODIFY */ import { ReactComponent as LogoGlue } from '../../../assets/images/Logos/logo-glue.svg?react';
import { withLogoClass } from '../../withLogoClass';
export const LogoGlueIcon = /* @__PURE__ */ withLogoClass(LogoGlue);
